import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { History } from 'history';

export const reactPlugin = new ReactPlugin();
import { AuthProvider } from './auth.service';

class TelemetryService {
  private appInsights: ApplicationInsights | undefined;

  constructor() {
    this.appInsights = undefined;
  }

  public initialize(instrumentationKey: string, browserHistory: History<unknown>): void {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey,
        maxBatchInterval: 500,
        disableFetchTracking: false,
        // TODO: look into this red squiggle
        // @ts-ignore
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: {
            history: browserHistory
          }
        }
      }
    });
    this.appInsights.loadAppInsights();

    const telemetryInitializer = envelope => {
      envelope.data['appversion'] = process.env.REACT_APP_VERSION;
      envelope.data['useremail'] = AuthProvider.getAccount().userName;
    };
    this.appInsights.addTelemetryInitializer(telemetryInitializer);

    this.appInsights.trackPageView();
  }

  public getApplicationInsights(): ApplicationInsights {
    if (this.appInsights == null) {
      throw new Error('app insights has not been initialized.');
    }

    return this.appInsights;
  }
}

export const ai = new TelemetryService();
